export const CHECKOUT_URL =
  'https://fitness-senior-pro.impultienda.ar/checkout'

export const MOCKUP_IMG =
  'https://cdn.magicpatterns.com/uploads/ccKLTFLxDSGYrrajC98iLx/ChatGPT_Image_24_ago_2026,_11_46_00_p.m..png'

export const REGULAR_PRICE = '$79 USD'
export const TODAY_PRICE = '$24.90 USD'
